import { Box, Button, CircularProgress, Grid2, InputAdornment, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ErrorModal from "../../utils/ErrorModal";

const AddVendor = () => {
  const [details, setDetails] = useState();
  const [email, setEmail] = useState();
  const [searchVendor, setSearchVendor] = useState()
  const navigate = useNavigate();
  const orgId = JSON.parse(localStorage.getItem("org"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [errors, setErrors] = useState({})
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorMsg, setErrorMsg] = useState();

  const handleChange = (e) => {
    const updatedValue =
      e.target.name === "pan" ? e.target.value.toUpperCase() : e.target.value;
    setDetails({ ...details, [e.target.name]: updatedValue });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = details || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (isEmpty(data.name)) newErrors.name = "Name is required";
    if (isEmpty(data.firmName)) newErrors.firmName = "Firm Name is required";

    if (isEmpty(data.email)) {
        newErrors.email = "Vendor Email ID is required";
      } else if (!emailRegex.test(data.email)) {
        newErrors.email = "Invalid email address";
      }

    if (isEmpty(data.pan)) {
      newErrors.pan = "PAN is required";
    } else if (!panRegex.test(data.pan)) {
      newErrors.pan = "Invalid PAN format (e.g. ABCDE1234F)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setBtnLoading(true)
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/vendor?orgId=${orgId}`,
        {
          email: details.email,
          name: details.name,
          firmName: details.firmName,
          pan: details.pan,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      navigate("/admin/vendors");
    } catch (error) {
        setOpenError(true);
        setErrorMsg(error.response.data.Exception || "Internal server error.");
      } finally {
        setBtnLoading(false);
      }
  };

  const handleSearchVendor = async () => {
    setSearchLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor/search-vendor?email=${email}&orgId=${orgId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setSearchVendor(res.data);
      setEmail("");
    } catch (error) {
      setOpenError(true);
      setErrorMsg(error.response.data.Exception || "Internal server error.");
    } finally {
      setSearchLoading(false);
    }
  };

  const handleAddVendor = async () => {
    if (btnLoading) return;
    setBtnLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-org?vendorId=${searchVendor.vendorId}&orgId=${orgId}`,
        {},
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setSearchVendor("");
      setEmail("");
      navigate("/admin/vendors");
    } catch (error) {
      setOpenError(true);
      setErrorMsg(error.response.data.Exception || "Internal server error.");
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div style={{position:'relative'}}>
        {btnLoading && <div className="loading-div"></div>}
        <Box className="dashboard-container">
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Box>
            <TextField
              placeholder="Search By Vendor Email ID"
              size="small"
              sx={{
                borderRadius: "12px",
                background: "#fff",
                width: 300,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  fontSize: "14px !important",
                },
                "&:hover": { background: "#D8E9F0" },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button onClick={handleSearchVendor}>
                      <SearchIcon fontSize="small" />
                    </Button>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearchVendor();
                }
              }}
              value={email}
            />
          </Box>
        </Box>
        {searchLoading ? (
          <Box textAlign={"center"}>
            <CircularProgress />
          </Box>
        ) : (
          searchVendor && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box width={"100%"} my={5}>
                <Grid2 container>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderTop: "1px solid #000" }}
                  >
                    Vendor ID
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{
                      borderTop: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    {searchVendor && searchVendor.vendorId}
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                  >
                    Name
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{
                      borderRight: "1px solid #000",
                    }}
                  >
                    {searchVendor && searchVendor.name}
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                  >
                    Email
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{
                      borderRight: "1px solid #000",
                    }}
                  >
                    {searchVendor && searchVendor.email}
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                  >
                    Firm Name
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{
                      borderRight: "1px solid #000",
                    }}
                  >
                    {searchVendor && searchVendor.firmName}
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                  >
                    PAN
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{
                      borderRight: "1px solid #000",
                    }}
                  >
                    {searchVendor && searchVendor.pan}
                  </Grid2>
                  
                </Grid2>
              </Box>
              <Box>
              <Button
                    className="btn-contained"
                    sx={{ margin: "0 !important" }}
                    onClick={handleAddVendor}
                    disabled={btnLoading}
                  >
                    {btnLoading ? "Adding" : "Add this vendor"}
                  </Button>
              </Box>
            </Box>
          )
        )}
      </Box>
      <Box className="dashboard-container">
        <Typography variant="h4" textAlign={"center"} mb={5}>
          Enter Vendor Details
        </Typography>
          <Grid2 container columnSpacing={4}
          sx={{ width: "60%", margin: "auto" }}
          >
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <label htmlFor="name">Vendor Name</label>
              <input
              className={`${errors.name && "input-error"}`}
                type="text"
                name="name"
                id="name"
                onChange={handleChange}
              />
              {errors.name && <p className="error">{errors.name}</p> }
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <label htmlFor="firmName">Vendor Email ID</label>
              <input
              className={`${errors.email && "input-error"}`}
                type="email"
                name="email"
                id="email"
                onChange={handleChange}
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <label htmlFor="firmName">Vendor Firm Name</label>
              <input
              className={`${errors.firmName && "input-error"}`}
                type="text"
                name="firmName"
                id="firmName"
                onChange={handleChange}
              />
              {errors.firmName && <p className="error">{errors.firmName}</p>}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <label htmlFor="pan">PAN</label>
              <input 
              className={`${errors.pan && "input-error"}`}
              type="text" name="pan" id="pan" onChange={handleChange} />
              {errors.pan && <p className="error">{errors.pan}</p>}
            </Grid2>
          </Grid2>
          <Box className="btn-container">
            <Button className="btn-contained" onClick={handleSubmit}>
                Save
            </Button>
          </Box>
      </Box>

      <ErrorModal open={openError} handleClose={() => setOpenError(false)} msg={errorMsg} />
    </div>
  );
};

export default AddVendor;